import React, { useState } from "react";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import Orders from "./Orders";

const OpsDashboard = () => {
  const [activeTab, setActiveTab] = useState("orders");

  const renderTabContent = () => {
    switch (activeTab) {
      case "orders":
        return <Orders />;
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#eef2f6" }}>
      <Container className="p-4 w-100" style={{ maxWidth: "100%" }}>
        <Row className="mb-4">
          <Col>
            <h3 className="fw-bold">
              Ops Dashboard
            </h3>
          </Col>
        </Row>

        {renderTabContent()}
      </Container>
    </div>
  );
};

export default OpsDashboard;
